import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccountsNumberPipe, OrgnrPipe, PrettyCompanyNamePipe } from '@nk/company-block';
import { AbrNumberOrThousandSepPipe } from '@nk/shared/pipes/abr-number-or-thousand-sep.pipe';
import { DateLaterThanPipe } from '@nk/shared/pipes/date-later-than.pipe';
import { FileLinkPipe } from '@nk/shared/pipes/file-link.pipe';
import { ReverseListPipe } from '@nk/shared/pipes/flip-list.pipe';
import { OrdinalPipe } from '@nk/shared/pipes/ordinal.pipe';
import { PrettyFilePath } from '@nk/shared/pipes/pretty-file-path';
import { HighlightTextPipe, NormalCasePipe, TitleCasePipe } from '@nk/ui-lib';
import { AbrNumberPipe } from './abr-number.pipe';
import { AddHttpPipe } from './add-http.pipe';
import { FilterPipe } from './filter.pipe';
import { FirstNamePipe } from './firstName.pipe';
import { GetDictValuePipe } from './get-dict-value.pipe';
import { GetObjValuePipe } from './get-obj-value.pipe';
import { GetLinkPipe } from './getLink.pipe';
import { milisecondsToDateStringPipe } from './miliseconds-to-date.pipe';
import { Name2SlugPipe } from './name2slug.pipe';
import { RiskLevelPipe } from './risk-level.pipe';
import { UrgencyLevelPipe } from './risk-urgency.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { SkipGramPipe } from './skip-gram.pipe';
import { ThousandSeparatedPipe } from '@nk/ui-lib';
import { UrlParsePipe } from './urlparse.pipe';

const PIPES = [
  GetLinkPipe,
  Name2SlugPipe,
  FilterPipe,
  UrlParsePipe,
  UrgencyLevelPipe,
  RiskLevelPipe,
  AbrNumberPipe,
  AddHttpPipe,
  SkipGramPipe,
  SafeUrlPipe,
  GetDictValuePipe,
  GetObjValuePipe,
  milisecondsToDateStringPipe,
  PrettyFilePath,
  DateLaterThanPipe,
  FileLinkPipe,
  OrdinalPipe,
  AbrNumberOrThousandSepPipe,
  ReverseListPipe,
];

@NgModule({
  imports: [
    CommonModule,
    ThousandSeparatedPipe,
    FirstNamePipe,
    PrettyCompanyNamePipe,
    OrgnrPipe,
    HighlightTextPipe,
    TitleCasePipe,
    AccountsNumberPipe,
    NormalCasePipe,
  ],
  declarations: PIPES,
  exports: [
    ...PIPES,
    ThousandSeparatedPipe,
    FirstNamePipe,
    PrettyCompanyNamePipe,
    OrgnrPipe,
    HighlightTextPipe,
    TitleCasePipe,
    AccountsNumberPipe,
    NormalCasePipe,
  ], // TODO: import pipes where it is really needed
})
export class PipeUtilsModule {}
